/* eslint-disable max-lines-per-function */
import $ from 'jquery';
import Keyboard from 'simple-keyboard';

import 'simple-keyboard/build/css/index.css';
import '../css/keyboard.css';
import { DEBUG_MODE } from '../spdConfig';

import * as Configuration from './testConfiguration';

const layoutLangeNormal = {
  RU: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  UA: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  EN: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  GE: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'ღ ჯ უ კ ე ნ გ შ წ ზ ხ ც [ ] |',
      'Ფ Ძ Ვ Თ Ა Პ Რ Ო Ლ Დ Ჟ : "',
      'Ჭ Ჩ Ყ Ს Მ Ი Ტ Ქ Ბ Ჰ , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Ღ Ჯ Უ Კ Ე Ნ Გ Წ Ზ Ხ Ც [ ] |',
      'ფ ძ ვ თ ა პ რ ო ლ დ ჟ : "',
      'ჭ ჩ ყ ს მ ი ტ ქ ბ , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '№ § {e} {e} ჱ {e} {e} {e} {e} ჴ {e} { } \\',
      "ჶ {e} ჳ {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} ჲ {e} {e} {e} ჵ < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgrshift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '№ § {e} {e} Ჱ {e} {e} {e} {e} Ჴ {e} { } \\',
      "Ჶ {e} Ჳ {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} Ჲ {e} {e} {e} Ჵ < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
  },
  PL: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space} {altgr}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space} {altgr}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} {e} {e} ę {e} {e} {e} {e} {e} ó {e} { } |',
      'ą ś {e} {e} {e} {e} {e} {e} ł : " {enter}',
      '{shift} ż ź ć {e} {e} ń {e} < > ? {shift}',
      '.com @ {space} {altgr}',
    ],
    altgrshift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} {e} {e} Ę {e} {e} {e} {e} {e} Ó {e} { } |',
      'Ą Ś {e} {e} {e} {e} {e} {e} Ł : " {enter}',
      '{shift} Ż Ź Ć {e} {e} Ń {e} < > ? {shift}',
      '.com @ {space} {altgr}',
    ],
  },
  TR: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  TJ: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  BY: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  UZ: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} й ц у к е н г ш щ з х ъ [ ] \\',
      "ф ы в а п р о л д ж э ; ' {enter}",
      '{shift} я ч с м и т ь б ю , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Й Ц У К Е Н Г Ш Щ З Х Ъ { } |',
      'Ф Ы В А П Р О Л Д Ж Э : " {enter}',
      '{shift} Я Ч С М И Т Ь Б Ю < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  DE: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  AR: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  SQ: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  SK: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  LT: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  ES: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  FR: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  VN: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  PH: {
    /// klawiatura do zdefiniowania obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p [ ] \\',
      "a s d f g h j k l ; ' {enter}",
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P { } |',
      'A S D F G H J K L : " {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  RO: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} q w e r t y u i o p ă î â',
      'a s d f g h j k l ș ț {enter}',
      '{shift} z x c v b n m , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} Q W E R T Y U I O P Ă Î Â',
      'A S D F G H J K L Ș Ț {enter}',
      '{shift} Z X C V B N M < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
  HI: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      '{tab} क व ए र त य उ इ ओ प [ ] \\',
      "अ स द फ ग ह ज ख ल ; ' {enter}",
      '{shift} ज़ क्ष च ब न म , . / {shift}',
      '.com @ {space}',
    ],
    shift: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{tab} ख ङ ऐ ऋ थ ञ ऊ ई औ फ़ { } |',
      'आ श ध {e} घ ः झ {e} {e} : " {enter}',
      '{shift} ज्ञ ष छ {e} ण {e} ं < > ? {shift}',
      '.com @ {space}',
    ],
    altgr: [],
    altgrshift: [],
  },
};

const layoutLange = {
  RU: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.com @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  UA: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  EN: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  GE: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Ღ Ჯ Უ Კ Ე Ნ Გ Წ Ზ Ხ Ც [ ] |',
      'Ფ Ძ Ვ Თ Ა Პ Რ Ო Ლ Დ Ჟ : "',
      'Ჭ Ჩ Ყ Ს Მ Ი Ტ Ქ Ბ Ჰ , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '№ § {e} {e} Ჱ {e} {e} {e} {e} Ჴ {e} { } \\',
      "Ჶ {e} Ჳ {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} Ჲ {e} {e} {e} Ჵ < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  PL: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P [ ] |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} Ę {e} {e} {e} {e} {e} Ó {e} { } \\',
      "Ą Ś {e} {e} {e} {e} {e} {e} Ł ; '",
      'Ż Ź Ć {e} {e} Ń {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  TR: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.com @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  TJ: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.com @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  BY: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.com @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  UZ: {
    // klawiatura do zdefiniowania - obecnie kopia rosyjskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Й Ц У К Е Н Г Ш Щ З Х Ъ [ ] |',
      'Ф Ы В А П Р О Л Д Ж Э : "',
      'Я Ч С М И Т Ь Б Ю , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.com @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  DE: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  AR: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  SQ: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  SK: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  LT: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  ES: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  FR: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  PH: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  VN: {
    /// klawiatura do zdefiniowania - obecnie kopia angielskiej
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P { } |',
      'A S D F G H J K L : "',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  RO: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'Q W E R T Y U I O P Ă Î Â',
      'A S D F G H J K L Ș Ț',
      'Z X C V B N M , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      '{e} {e} {e} {e} {e} {e} {e} {e} {e} {e} { } \\',
      "{e} {e} {e} {e} {e} {e} {e} {e} {e} ; '",
      '{e} {e} {e} {e} {e} {e} {e} < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
  HI: {
    default: [
      '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
      'क व ए र त य उ इ ओ प [ ] |',
      'अ स द फ ग ह ज ख ल : "',
      'ज़ क्ष च ब न म , . ? /',
      '.COM @ {space} {altgr} {enter}',
    ],
    altgr: [
      '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
      'ख ङ ऐ ऋ थ ञ ऊ ई औ फ़ { } \\',
      "आ श ध {e} घ ः झ {e} {e} ; '",
      'ज्ञ ष छ {e} ण {e} ं < > / \\',
      '.COM @ {space} {altgr} {enter}',
    ],
    shift: [],
  },
};

export class SPDKeyboard {
  static disableKeyboard = false;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  static onInput = () => {};
  protected static setCaretPosition(
    $elem: JQuery<HTMLInputElement> | null,
    caretPos: number,
  ) {
    if ($elem) {
      if ($elem.length === 0) {
        return;
      } // Ensure element exists

      const elem = $elem[0]; // Get the native HTMLInputElement from the jQuery object

      if (elem !== null) {
        if (elem.setSelectionRange) {
          // For modern browsers
          elem.focus();
          elem.setSelectionRange(caretPos, caretPos);
          DEBUG_MODE && console.log('setCaretPosition new browsers');
        } else {
          // Fallback for other browsers
          DEBUG_MODE && console.log('setCaretPosition old browsers');
          elem.focus();
        }
      }
    }
  }

  public static showEnterKeyboard(value?: string) {
    if (SPDKeyboard.disableKeyboard) {
      if (value) {
        $('.input').val(value);
      }
      $('.input')[0].focus(); // Get the native HTMLInputElement from the jQuery object
      return;
    }
    const keyboard = new Keyboard({
      onChange: input => onChange(input),
      onKeyPress: (button: string) => onKeyPress(button),
      theme: 'enter-keyboard',
      mergeDisplay: true,
      display: {
        '{enter}': 'Zatwierdź zmianę',
      },
      layout: {
        default: ['{enter}'],
      },
      buttonTheme: [
        {
          class: 'hg-special',
          buttons: '{enter}',
        },
      ],
    });

    /**
     * Update simple-keyboard when input is changed directly
     */
    $('.input').on('input', event => {
      const value = $(event.target).val() as string;
      if (value) {
        keyboard.setInput(value);
      }
    });

    function onChange(input: string) {
      const elem = $('.input') as JQuery<HTMLInputElement>;
      SPDKeyboard.onInput(); // poinformowanie, że pole zostało zmodyfikowane z wirtualnej klawiatury
      elem.val(input);
      SPDKeyboard.setCaretPosition(elem, input.length); ///obejście problemu przeskakiwania karetki na początek input
      DEBUG_MODE && console.log('Input PIN changed', input);
    }

    function onKeyPress(button: string) {
      if (button === '{enter}') {
        $('.input').trigger(
          $.Event('keypress', {
            charCode: 13,
            code: 'Enter',
            key: 'Enter',
            which: 13,
            keyCode: 13,
          }),
        );
      }
      DEBUG_MODE && console.log('Button pressed', button);
    }
    if (value) {
      $('.input').val(value);
      keyboard.setInput(value);
    }
    /**
     * Update simple-keyboard when input is changed directly
     */
    $('.input').on('input', e => {
      const value = $(e.target).val() as string;
      if (value) {
        keyboard.setInput(value);
      }
    });
    $('.input')[0].focus(); // Get the native HTMLInputElement from the jQuery object

    return keyboard;
  }

  public static showPINKeyboard(value?: string) {
    if (SPDKeyboard.disableKeyboard) {
      if (value) {
        $('.input').val(value);
      }
      $('.input')[0].focus(); // Get the native HTMLInputElement from the jQuery object
      return;
    }
    const keyboard = new Keyboard({
      onChange: input => onChange(input),
      onKeyPress: (button: string) => onKeyPress(button),
      theme: 'hg-theme-default hg-layout-default myTheme pin-keyboard',
      mergeDisplay: true,
      display: {
        '{enter}': 'enter',
      },
      layout: {
        default: [
          '1 2 3',
          '4 5 6',
          '7 8 9',
          '- + 0 * .',
          '{bksp} {space} {enter}',
        ],
      },
      buttonTheme: [
        {
          class: 'hg-special',
          buttons: '{bksp} {enter}',
        },
      ],
    });

    /**
     * Update simple-keyboard when input is changed directly
     */
    $('.input').on('input', event => {
      const value = $(event.target).val() as string;
      if (value) {
        keyboard.setInput(value);
      }
    });

    function onChange(input: string) {
      const elem = $('.input') as JQuery<HTMLInputElement>;
      SPDKeyboard.onInput(); // poinformowanie, że pole zostało zmodyfikowane z wirtualnej klawiatury
      elem.val(input);
      SPDKeyboard.setCaretPosition(elem, input.length); ///obejście problemu przeskakiwania karetki na początek input
      DEBUG_MODE && console.log('Input PIN changed', input);
    }

    function onKeyPress(button: string) {
      if (button === '{enter}') {
        $('.input').trigger(
          $.Event('keypress', {
            charCode: 13,
            code: 'Enter',
            key: 'Enter',
            which: 13,
            keyCode: 13,
          }),
        );
      }
      DEBUG_MODE && console.log('Button pressed', button);
    }
    if (value) {
      $('.input').val(value);
      keyboard.setInput(value);
    }
    /**
     * Update simple-keyboard when input is changed directly
     */
    $('.input').on('input', e => {
      const value = $(e.target).val() as string;
      if (value) {
        keyboard.setInput(value);
      }
    });
    $('.input')[0].focus(); // Get the native HTMLInputElement from the jQuery object

    return keyboard;
  }

  public static showFullKeyboard(
    lange: Configuration.Lange,
    value: string,
    onlyCapital = true,
  ) {
    if (SPDKeyboard.disableKeyboard) {
      if (value) {
        $('.input').val(value);
      }
      $('.input')[0].focus(); // Get the native HTMLInputElement from the jQuery object
      return;
    }
    let selectedInput: HTMLInputElement;
    const layout = onlyCapital ? layoutLange : layoutLangeNormal;
    const keyboard = new Keyboard({
      disableButtonHold: true,
      onChange: input => onChange(input),
      onKeyPress: (button: string) => onKeyPress(button),
      theme: 'hg-theme-default hg-layout-default myTheme',
      mergeDisplay: true,
      display: {
        '{enter}': 'enter',
        '{altgr}': 'alt gr',
        '{bksp}': 'backspace',
        '{tab}': 'tab',
        '{lock}': 'caps lock',
        '{shift}': 'shift',
        '{e}': ' ',
      },
      layout: {
        default: layout[lange].default,
        shift: layout[lange].shift,
        altgr: layout[lange].altgr,
      },
      buttonTheme: [
        {
          class: 'hg-special',
          buttons: ' {shift} {enter} {bksp} {altgr} {tab}',
        },
        {
          class: 'hg-highlight',
          buttons: '{enter}',
        },
      ],
    });

    $('.input').on('focus', onInputFocus);
    $('.input').on('input', onInputChange);
    $('.input').first().trigger('focus');

    if (value) {
      $('.input').val(value);
      keyboard.setInput(value);
    }

    function onInputFocus(event: JQuery.TriggeredEvent) {
      if (event.target) {
        selectedInput = event.target as HTMLInputElement;
        const name = $(event.target).attr('name');

        keyboard.setOptions({
          inputName: name,
        });
        DEBUG_MODE && console.log('onInputFocus', value, name);
      }
    }

    function onInputChange(event: JQuery.TriggeredEvent) {
      if (event.target) {
        const value = $(event.target).val() as string;
        const name = $(event.target).attr('name');
        keyboard.setInput(value, name);
        DEBUG_MODE && console.log('Input changed from keyboard', value, name);
      }
    }

    function onChange(input: string) {
      const elem = $(selectedInput || '.input');
      SPDKeyboard.onInput(); // poinformowanie, że pole zostało zmodyfikowane z wirtualnej klawiatury
      elem.val(input);
      SPDKeyboard.setCaretPosition(elem, input.length); ///obejście problemu przeskakiwania karetki na początek input
      DEBUG_MODE && console.log('Input Full changed', input);
    }

    function onKeyPress(button: string) {
      DEBUG_MODE && console.log('Button pressed', button);

      if (button === '{enter}') {
        $(selectedInput).trigger(
          $.Event('keypress', {
            charCode: 13,
            code: 'Enter',
            key: 'Enter',
            which: 13,
            keyCode: 13,
          }),
        );
      }
      if (button === '{altgr}') {
        handleAltGr();
      }
      if (button === '{shift}') {
        handleShift();
      }
      if (button !== '{altgr}' && button !== '{shift}') {
        handleDefault();
      }
    }

    function handleAltGr() {
      const currentLayout = keyboard.options.layoutName;
      let layoutToggle = 'altgr';

      switch (currentLayout) {
        case 'altgr':
          layoutToggle = 'default';
          break;
        case 'altgrshift':
          layoutToggle = 'shift';
          break;
        case 'shift':
          layoutToggle = 'altgrshift';
          break;
        case 'default':
          layoutToggle = 'altgr';
          break;
      }

      keyboard.setOptions({
        layoutName: layoutToggle,
      });
    }
    function handleDefault() {
      const currentLayout = keyboard.options.layoutName;
      let layoutToggle = 'default';

      switch (currentLayout) {
        case 'altgr':
          layoutToggle = 'default';
          break;
        case 'altgrshift':
          layoutToggle = 'shift';
          break;
        case 'shift':
          layoutToggle = 'default';
          break;
        case 'default':
          layoutToggle = 'default';
          break;
      }

      if (currentLayout !== layoutToggle) {
        keyboard.setOptions({
          layoutName: layoutToggle,
        });
      }
    }

    function handleShift() {
      const currentLayout = keyboard.options.layoutName;
      let layoutToggle = 'shift';

      switch (currentLayout) {
        case 'altgr':
          layoutToggle = 'altgrshift';
          break;
        case 'altgrshift':
          layoutToggle = 'altgr';
          break;
        case 'shift':
          layoutToggle = 'default';
          break;
        case 'default':
          layoutToggle = 'shift';
          break;
      }

      keyboard.setOptions({
        layoutName: layoutToggle,
      });
    }
  }
}
